<template>
    <div class="tl-row">
        <div class="tl-columnheader">
            <h2 class="tl-tit">시공 희망일 <span class="color-red">*</span></h2>
        </div>
        <div class="tl-cell">
            <label v-for="(text, i) in items" :key="i" class="check-block" @click="setTargetDate">
                <input type="checkbox" class="input" :value="text" :checked="text === input" />
                <span class="button button--border-primary">{{ text }}</span>
            </label>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        input: String || null,
    },
    data() {
        return {
            items: ["미정", "1개월 이내", "2개월 이내"],
        };
    },
    methods: {
        setTargetDate(event) {
            this.$emit("set-input", { targetDate: event.target.value });
        },
    },
};
</script>
